var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18.286,
    viewBox: "0 0 16 18.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "lock-solid",
    d: "M5.143,5.143V6.857h5.714V5.143a2.857,2.857,0,1,0-5.714,0ZM2.857,6.857V5.143a5.143,5.143,0,1,1,10.286,0V6.857h.571A2.288,2.288,0,0,1,16,9.143V16a2.288,2.288,0,0,1-2.286,2.286H2.286A2.288,2.288,0,0,1,0,16V9.143A2.288,2.288,0,0,1,2.286,6.857Z",
    fill: "#44eaae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSolid);
export default __webpack_public_path__ + "static/media/lock-solid.3539105004c10f3546b80b160cd3eb23.svg";
export { ForwardRef as ReactComponent };